<rcl-guest-summary-list>
	<rcl-boarding-pass id="rcl-boarding-pass" class="rcl-col-sm-12 rcl-col-md-6" *ngFor="let guest of guestsCompleted; trackBy: trackByFn">
		<rcl-guest-header-wrap
			id="rcl-boarding-pass__header-wrap"
			[disabled]="guestService.isGuestLocked(guest) || (session && session.sailingClosed)"
			[attr.aria-label]="
				guestService.isGuestLocked(guest) ? guest.firstName + ' ' + getGuestLastName(guest) + ' is currently unavailable' : ''
			"
		>
			<button
				id="header-wrap__button"
				(click)="editGuest(guest)"
				[disabled]="session && session.sailingClosed"
				*ngIf="!guestService.isGuestLocked(guest)"
			>
				<rcl-guest-header
					id="button__rcl-guest-header"
					[guestFirstName]="guest.firstName"
					[guestLastName]="getGuestLastName(guest)"
					[imgSrc]="guest.base64Image"
					[maskForContentSquare]="true"
				>
					<rcl-section-description id="rcl-guest-header__section-description">{{
						bundle && bundle['label.reservation.title'] + ' ' + guest.bookingId
					}}</rcl-section-description>
				</rcl-guest-header>
			</button>
			<rcl-guest-header
				id="header-wrap__guest-header"
				[guestFirstName]="guest.firstName"
				[guestLastName]="getGuestLastName(guest)"
				[disabled]="true"
				*ngIf="guestService.isGuestLocked(guest)"
				[maskForContentSquare]="true"
			>
				<rcl-section-description id="guest-header__section-description" tabindex="-1" class="disabled-text">
					{{ bundle && bundle['label.reservation.title'] + ' ' + guest.bookingId }}
				</rcl-section-description>
			</rcl-guest-header>
		</rcl-guest-header-wrap>

		<rcl-boarding-pass-options id="rcl-boarding-pass__options">
			<div class="rcl-row">
				<rcl-guest-action
					id="options__action-get-guest"
					class="rcl-col-sm-12"
					[option]="{
						label: bundle && bundle['label.boarding.pass'],
						icon: 'boardingPass',
						status: guest.boardingPassPendingStatus ? 'pending' : 'reprint'
					}"
					(actionEvent)="getGuestBoardingPass(guest.guestId, guest.bookingId)"
					[name]="guest.firstName + ' ' + getGuestLastName(guest)"
					[maskForContentSquare]="true"
				>
					<rcl-guest-action-status id="action-get-guest__status" *ngIf="guest.boardingPassPendingStatus"
						><span id="action-get-guest__status__unavailable" [class.unavailable]="guestService.isGuestLocked(guest)">{{
							bundle && bundle['label.pending']
						}}</span></rcl-guest-action-status
					>

					<rcl-tooltip
						[id]="'tooltippass'"
						[buttonText]="bundle && bundle['button.okay']"
						*ngIf="guest.boardingPassPendingStatus"
						[tooltipDescription]="guestStatus(guest)"
					>
						<div>{{ guestStatus(guest) }}</div>
					</rcl-tooltip>
				</rcl-guest-action>
			</div>
		</rcl-boarding-pass-options>
	</rcl-boarding-pass>
</rcl-guest-summary-list>
